import React from "react";
import "@/styles/fast-docs.css";

/** Our mark for speed: a heavy pound sign on a white chip — the same everywhere the Fast track shows. */
export function FastMark({ size = 16, className = "" }) {
  return (
    <span className={`fmark ${className}`} style={{ "--fm": `${size}px` }} aria-hidden="true">£</span>
  );
}

/** The case came in with all three documents lenders ask for first — nothing to wait on. */
export function FastTrackTag({ lead, testId }) {
  if (!lead?.fast_track) return null;
  return (
    <span className="tag tag-fast" title="All three documents lenders ask for first came in with the application"
          data-testid={testId || `fast-track-chip-${lead.id}`}>
      <FastMark size={15} />
      <span className="tag-fast-txt">Fast track</span>
    </span>
  );
}

export default FastTrackTag;
